<template>
	<div id="app">
		<router-view />
		<!-- 实名制 AI 查询：登录后全局可用 -->
		<ai-query v-if="showAiQuery" />
	</div>
</template>

<script>
import AiQuery from '@/components/AiQuery/index.vue'
import { getToken } from '@/utils/auth'

export default {
	name: 'App',
	components: { AiQuery },
	computed: {
		showAiQuery() {
			const path = this.$route ? this.$route.path : ''
			if (!path || path === '/login' || path.indexOf('/redirect') === 0) {
				return false
			}
			return !!getToken()
		}
	}
};
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/App.vue